module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "45px",
      "overflow": "hidden"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_vm._v("左右布局（百分比）")]), _vm._v(" "), _c('mt-layout-left-right', [_c('mt-layout-left-right-item', {
    attrs: {
      "slot": "left",
      "position": "left",
      "percentage": "30"
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "mt-bg-primary mt-color-white"
  }, [_vm._v("左30%")])]), _vm._v(" "), _c('mt-layout-left-right-item', {
    attrs: {
      "slot": "right",
      "position": "right",
      "percentage": "70"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "mt-bg-warning mt-color-white"
  }, [_vm._v("右70%")])])], 1)], 1), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_vm._v("左右布局（像素）")]), _vm._v(" "), _c('mt-layout-left-right', {
    on: {
      "click": _vm.handleclick
    }
  }, [_c('mt-layout-left-right-item', {
    attrs: {
      "slot": "left",
      "position": "left",
      "percentage": "60px"
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "mt-bg-primary mt-color-white"
  }, [_vm._v("左60px")])]), _vm._v(" "), _c('mt-layout-left-right-item', {
    attrs: {
      "slot": "right",
      "position": "right",
      "percentage": "calc(100% - 40px)"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "mt-bg-warning mt-color-white"
  }, [_vm._v("右(100%-40px)")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4238cdd6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/layout-left-right.vue
// module id = 560
// module chunks = 0